(function () {
  if (window.QLSPolishedCommerceUIV125) return;
  window.QLSPolishedCommerceUIV125 = true;

  var dialog;
  var activeWidget;

  function cleanText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function currentWidget(widget) {
    if (widget && widget.isConnected) return widget;
    return document.querySelector('.cart-drawer__summary .simply-insurance.widget, #cart-summary .simply-insurance.widget, .simply-insurance.widget');
  }

  function getToggle(widget) {
    widget = currentWidget(widget);
    if (!widget) return null;
    return widget.querySelector('input.cart-insurance-input[type="checkbox"], input[type="checkbox"], [role="switch"], button[class*="toggle" i]');
  }

  function toggleIsOn(toggle) {
    if (!toggle) return false;
    if (toggle.matches && toggle.matches('input[type="checkbox"]')) return !!toggle.checked;
    return toggle.getAttribute('aria-checked') === 'true' || toggle.classList.contains('active') || toggle.classList.contains('checked');
  }

  function setProtection(widget, shouldEnable) {
    widget = currentWidget(widget);
    if (!widget) return false;

    var input = widget.querySelector('input.cart-insurance-input[type="checkbox"], input[type="checkbox"]');
    if (input) {
      if (!!input.checked === shouldEnable) return true;
      var label = input.id ? widget.querySelector('label[for="' + CSS.escape(input.id) + '"]') : null;
      label = label || widget.querySelector('.switch-button label.switch, label.switch, .switch');
      if (label && typeof label.click === 'function') label.click();
      else input.click();
      return true;
    }

    var toggle = getToggle(widget);
    if (toggle && toggleIsOn(toggle) !== shouldEnable) {
      toggle.click();
      return true;
    }
    return !!toggle;
  }

  function ensureDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('div');
    dialog.className = 'qls-protection-dialog';
    dialog.hidden = true;
    dialog.innerHTML = '' +
      '<div class="qls-protection-dialog__backdrop" data-qls-protection-close></div>' +
      '<section class="qls-protection-dialog__panel" role="dialog" aria-modal="true" aria-labelledby="qls-protection-title" tabindex="-1">' +
        '<button class="qls-protection-dialog__close" type="button" aria-label="Close" data-qls-protection-close>&times;</button>' +
        '<div class="qls-protection-dialog__hero" aria-hidden="true"><div class="qls-protection-dialog__box"></div><div class="qls-protection-dialog__shield">✓</div></div>' +
        '<h2 id="qls-protection-title">Your bottles, protected</h2>' +
        '<p class="qls-protection-dialog__intro">Helps cover loss, damage or theft while your order is in transit.</p>' +
        '<div class="qls-protection-benefits">' +
          '<div class="qls-protection-benefit"><span class="qls-protection-benefit__icon"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 8.5 12 5l7 3.5v7L12 19l-7-3.5v-7Z M12 5v14 M5 8.5l7 3.5 7-3.5"/><path d="M8.2 4.7 12 3l3.8 1.7"/></svg></span><div><strong>Lost</strong><p>Coverage support if your order is lost in transit.</p></div></div>' +
          '<div class="qls-protection-benefit"><span class="qls-protection-benefit__icon"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 8.5 12 5l7 3.5v7L12 19l-7-3.5v-7Z M5 8.5l7 3.5 7-3.5"/><path d="m12 5-1 4 2 2-2 3 1 5"/></svg></span><div><strong>Damaged</strong><p>Help if bottles arrive damaged during shipping.</p></div></div>' +
          '<div class="qls-protection-benefit"><span class="qls-protection-benefit__icon"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3.5 19 6v5.4c0 4.2-2.8 7.4-7 9.1-4.2-1.7-7-4.9-7-9.1V6l7-2.5Z"/><path d="M12 8v5 M12 16h.01"/></svg></span><div><strong>Stolen</strong><p>Coverage support if a delivered shipment is stolen.</p></div></div>' +
        '</div>' +
        '<p class="qls-protection-dialog__terms">Claims are subject to the package-protection terms and eligibility requirements.</p>' +
      '</section>';
    document.body.appendChild(dialog);

    dialog.querySelectorAll('[data-qls-protection-close]').forEach(function (el) {
      el.addEventListener('click', closeDialog);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && dialog && !dialog.hidden) closeDialog();
    });
    return dialog;
  }

  function openDialog(widget) {
    activeWidget = widget;
    var el = ensureDialog();
    el.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    window.setTimeout(function () { el.querySelector('.qls-protection-dialog__panel').focus(); }, 20);
  }

  function closeDialog() {
    if (!dialog) return;
    dialog.hidden = true;
    document.documentElement.style.overflow = '';
  }

  function decorateCheckoutProtection(container) {
    if (!container || container.dataset.qlsCheckoutPolished === 'true') return;
    container.dataset.qlsCheckoutPolished = 'true';
    container.classList.add('qls-checkout-protection-polished');

    var label = container.querySelector('.ssp-checkout-text-wrapper');
    var oldInfo = container.querySelector('.btnCstm.tooltipCstm');
    if (oldInfo) oldInfo.style.display = 'none';

    if (label && !label.querySelector('.qls-checkout-protection-details')) {
      var details = document.createElement('button');
      details.type = 'button';
      details.className = 'qls-checkout-protection-details';
      details.textContent = 'More information';
      details.setAttribute('aria-haspopup', 'dialog');
      details.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        activeWidget = container;
        openDialog(container);
      });
      label.appendChild(details);
    }
  }

  function decorateProtection(widget) {
    if (!widget || widget.dataset.qlsPolished === 'true') return;
    widget.dataset.qlsPolished = 'true';
    widget.classList.add('qls-protection-polished');

    var titleWrap = widget.querySelector('.insurance-title-wrap') || widget.querySelector('.title-image-wrap') || widget;
    var description = widget.querySelector('.plan-description');
    if (description) {
      var text = cleanText(description.textContent).toLowerCase();
      if (!text || text.indexOf('loss') === -1) description.textContent = 'Covers loss, damage & theft';
    }

    if (!titleWrap.querySelector('.qls-protection-meta')) {
      var meta = document.createElement('div');
      meta.className = 'qls-protection-meta';
      meta.innerHTML = '<span class="qls-protection-optional">Optional</span><button type="button" class="qls-protection-details">Details</button>';
      titleWrap.appendChild(meta);
      meta.querySelector('.qls-protection-details').addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        openDialog(widget);
      });
    }
  }

  function polishKlaviyo(root) {
    (root || document).querySelectorAll('button, a').forEach(function (el) {
      var text = cleanText(el.textContent).toLowerCase();
      if (text === 'notify me when available' || text === 'notify when available' || text === 'notify me') {
        el.classList.add('klaviyo-bis-trigger');
      }
    });
  }

  function scan(root) {
    (root || document).querySelectorAll('.simply-insurance.widget').forEach(decorateProtection);
    (root || document).querySelectorAll('.ssp-checkout-button-container').forEach(decorateCheckoutProtection);
    polishKlaviyo(root || document);
  }

  function init() {
    scan(document);
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('.simply-insurance.widget')) decorateProtection(node);
          if (node.matches && node.matches('.ssp-checkout-button-container')) decorateCheckoutProtection(node);
          scan(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
    document.addEventListener('qls:shipping-protection:settled', function () { scan(document); });
    [400, 1000, 2200, 4500].forEach(function (delay) { setTimeout(function () { scan(document); }, delay); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
